import React, {Component} from 'react';
import firebase from 'firebase';
import ReactNotify from 'react-notify'
import {Redirect} from 'react-router-dom';

import createHistory from 'history/createBrowserHistory';
const history = createHistory();

class Login extends Component {
    constructor() {
        super();
    }

    logIn(e) {
        const email = this.refs.email.value.trim().toLowerCase();
        const password = this.refs.pwd.value.trim();

        if (email != "" && password != "") {
            const _this = this;
            firebase.auth().signInWithEmailAndPassword(email, password).then((response) => {
                let url = window.location.href;
                url = url.replace("login", "dashboard");
                window.location.href = url;

                // _this.props.history.push("/dashboard");
                // <Redirect to="/dashboard"/>
            }).catch((error) => {
                _this.refs.notificator.error("Error", error.message, 10000);
                console.error(error);
            })
        }
    }

    render() {
        return (
            <div className="app flex-row align-items-center">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <div className="card-group mb-0">
                                <div className="card p-4">
                                    <div className="card-block">
                                        <h1>Login</h1>
                                        <p className="text-muted">Sign In to your account</p>
                                        <div className="input-group mb-3">
                                            <span className="input-group-addon"><i className="icon-user"></i></span>
                                            <input type="email" ref="email" className="form-control"
                                                   placeholder="Username"/>
                                        </div>
                                        <div className="input-group mb-4">
                                            <span className="input-group-addon"><i className="icon-lock"></i></span>
                                            <input type="password" ref="pwd" className="form-control"
                                                   placeholder="Password"/>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <button type="button" className="btn btn-primary px-4"
                                                        onClick={(e) => this.logIn(e)}>Login
                                                </button>
                                            </div>
                                            {/* <div className="col-6 text-right">
                                             <button type="button" className="btn btn-link px-0">Forgot password?
                                             </button>
                                             </div> */}
                                        </div>
                                    </div>
                                </div>

                                {/*
                                 <div className="card card-inverse card-primary py-5 d-md-down-none"
                                 style={{ width: 44 + '%' }}>
                                 <div className="card-block text-center">
                                 <div>
                                 <h2>Sign up</h2>
                                 <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                 tempor incididunt ut labore et dolore magna aliqua.</p>
                                 <button type="button" className="btn btn-primary active mt-3">Register
                                 Now!
                                 </button>
                                 </div>
                                 </div>
                                 </div>
                                 */}

                            </div>
                        </div>
                    </div>
                </div>

                <ReactNotify ref="notificator"/>

            </div>
        );
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js